module.exports = __webpack_public_path__ + "img/M1.1.8994375b.jpg";